import { Button, Form, Icon, Input, Layout, Spin } from 'antd';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import querystring from 'querystring';
import React from 'react';
import { connect } from 'react-redux';
import { Constant } from '../../config';
import { showMenuDisplayAction } from '../../store/actions/headerBar';
import MyModal from '../Modal';
import './SignIn.css';



const { Content } = Layout

class SignIn extends React.Component {
	state = { 
		loading: false,
		errTxt: "",
	}

	componentWillMount(){
		let token = localStorage.getItem(Constant.SessionKey)
		if (token) {
			let exp = 0
			try {
				let tmp = jwtDecode(token)
				exp = tmp.exp
			} catch(err) {
				localStorage.removeItem(Constant.SessionKey)
				return
			}

			if (Date.now() < exp * 1000) {
				this.props.showMenuDisplayAction()
				this.props.history.push('/')
			}
		}
  }

	handleSubmit = e => {
		e.preventDefault();

		this.props.form.validateFields(async (err, values) => {
			if (err) 
      	return

      this.setState({ 
				loading: true,
				errTxt: "",
			})

      let data = {
        "email": values.email,
        "password": values.password
      }
      let opt = {
        url: Constant.AUTH_API,
        method: "POST",
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        data: querystring.stringify(data)
      }
      let eMsg = "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง"

      try {
        let resp = await axios(opt)

        setTimeout(()=>{
	        this.setState({ loading: false })

	        if (resp.status !== 200 || !resp.data || !resp.data.token || resp.data.token==="") {
	          
	          this.setState({ errTxt: eMsg = "[001] "+eMsg })
	          console.log(resp)

	          return
	        }

	        let dToken = jwtDecode(resp.data.token)
	        let myName = dToken.email
	        if (dToken.firstname !== "") {
	        	myName = dToken.firstname+" "+dToken.lastname
	        }

	        localStorage.setItem("myToken", resp.data.token)
	        localStorage.setItem("myName", myName)
					this.props.showMenuDisplayAction()
					
					const { from } = this.props.location.state || {
            from: { pathname: '/', search: '' },
          };
          window.location.href = from.pathname + from.search;
	        // this.props.history.push("/")
        }, 2000)
      } catch(err) {
      	setTimeout(()=>{
	      	this.setState({ loading: false })

	      	let e = err.response
	      	if (e && e.data && e.data && e.data.error) {
	          let tmp = "["+e.data.error.code+"] "
	          if (e.data.error.code === 868) {
	          	tmp += "Account ของคุณถูกบล็อก"
	          } else if (e.data.error.code !== 801) {
	            tmp += "อีเมล หรือ รหัสผ่าน ไม่ถูกต้อง"
	          } else {
	            tmp += e.data.error.name
	          }
	          eMsg = tmp
	        } else {
	          eMsg = "[002] "+eMsg
	          console.log(e)
	        }

	        this.setState({ errTxt: eMsg })
      	}, 2000)
      }
		})
	}

	forgetPassword = () => {
		MyModal.info("ยังไม่สามารถใช้งาน")
	}

	render() {
		const { getFieldDecorator } = this.props.form;

		return (
			<Content className="signin-form">
				<Spin spinning={this.state.loading} tip="กำลังเข้าสู่ระบบ...">

				<Form onSubmit={this.handleSubmit}>
					<Form.Item>
		        {getFieldDecorator('email', {
		          rules: [{ required: true, message: 'กรุณากรอกอีเมล' }],
		        })(
		          <Input
		            prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
		            type="email"
		            placeholder="อีเมล"
		          />,
		        )}
		      </Form.Item>
		      <Form.Item>
		        {getFieldDecorator('password', {
		          rules: [{ required: true, message: 'กรุณากรอกรหัสผ่าน' }],
		        })(
		          <Input
		            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
		            type="password"
		            placeholder="รหัสผ่าน"
		          />,
		        )}
		      </Form.Item>
		      <Form.Item>
		        <a className="signin-form-forgot" onClick={()=>this.forgetPassword()}>
		          ลืมรหัสผ่าน
		        </a>
		        <Button type="primary" htmlType="submit" className="signin-form-button">
		          เข้าสู่ระบบ
		        </Button>
		      </Form.Item>
		      <Form.Item>
		      	<span>{this.state.errTxt}</span>
		      </Form.Item>
				</Form>

				</Spin>
	    </Content>
		)
	}
}

const SignInForm = Form.create({ name: 'sign_form' })(SignIn);

const mapDispatchToProps = {
	showMenuDisplayAction
}

export default connect(null, mapDispatchToProps)(SignInForm)


// WEBPACK FOOTER //
// ./src/containers/SignIn/index.js